<template>
  <section class="custom-container" id="recommendedProduct">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h4 class="font-w-600 fontsize-heavy text-color-theme-dark mb-3">
        محصولات ثریا مارکت
      </h4>
      <ul class="d-flex align-items-center gap-20">
        <li
          @click="setActiveProducts(tab)"
          v-for="(tab, index) in tabs"
          :key="index"
        >
          <a
            :class="{ active: activeTab == tab.name }"
            class="font-w-600 fontsize-mini text-color-theme-dark w-s-nowrap"
            aria-controls="home"
            aria-selected="true"
            >{{ tab.label }}</a
          >
        </li>
      </ul>
    </div>
    <div class="mt-3 product-grid">
      <Product
        class="product"
        v-for="(product, index) in products?.slice(0, 8)"
        :key="index"
        :product="product"
      ></Product>
    </div>
  </section>
</template>

<script>
import Product from "@/parts/Front/components/product/Product";

export default {
  name: "RecommendedProduct",
  components: {
    Product,
  },
  data() {
    return {
      activeTab: "new-products",
      readyProducts: null,
      tabs: [
        {
          name: "new-products",
          label: "همه محصولات",
        },
        {
          name: "most-discounts",
          label: "محصولات تخفیفی",
        },
      ],
    };
  },
  mounted() {
    this.setReadyProducts(this.activeTab);
  },
  computed: {
    products() {
      return this.readyProducts;
    },
  },
  methods: {
    async setReadyProducts(key) {
      this.activeTab = key;
      this.readyProducts = null;
      let res = await this.$store.dispatch("front/getIndexPageContent", key);
      this.readyProducts = res;
    },
    setActiveProducts(tab) {
      this.activeTab = tab.name;
      this.setReadyProducts(this.activeTab);
    },
  },
};
</script>

<style scoped>
#recommendedProduct .product-grid {
  display: grid;
  grid-template-columns: repeat(4, 24%);
  column-gap: calc((100% - (4 * 24%)) / 3);
  row-gap: 12px;
}
#recommendedProduct .active {
  border-radius: 30px;
  padding: 0.5rem 1rem;
  background-color: var(--color-theme2);
  color: var(--color-white) !important;
}

/* @media screen and ((min-width: 769px)) {
  #recommendedProduct .product:nth-child(even) {
    transform: translateY(50px);
  }
}
@media (min-width: 541px) and (max-width: 769px) {
  #recommendedProduct .product:nth-child(3n-1) {
    transform: translateY(50px);
  }
}
@media screen and (max-width: 541px) {
  #recommendedProduct .product:nth-child(even) {
    transform: translateY(50px);
  }
} */

@media screen and (max-width: 769px) {
  #recommendedProduct .product-grid {
    display: grid;
    grid-template-columns: repeat(3, 32%);
    column-gap: calc((100% - (3 * 32%)) / 2);
    row-gap: 12px;
  }
}
@media screen and (max-width: 540px) {
  #recommendedProduct .product-grid {
    display: grid;
    grid-template-columns: repeat(2, 49%);
    column-gap: calc((100% - (2 * 49%)) / 1);
    row-gap: 12px;
  }
}
</style>
